import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateZipcodeInternacionalActions } from "store/ducks/settings/zipcode-internacional";

export function* paginateZipcodeInternacionalRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/zipcode-internacional?${queryString}`
    );

    const { zipcode, pagination } = responseBody;
    yield put(PaginateZipcodeInternacionalActions.success(zipcode, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateZipcodeInternacionalActions.failure(errorMessage));
  }
}
